import { Component, OnInit } from '@angular/core';
import { HaFeedbackserviceService } from '../../services/HaFeedback.service';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-feedback',
  templateUrl: './ha-feedback.component.html',
  styleUrls: ['./ha-feedback.component.css']
})

export class HaFeedbackComponent implements OnInit {
  score: number = 0;
  displayRatingScore = 0;
  element: HTMLElement;
  feedbackDataFiltered: any[] = [];
  feedbackDataOriginal: any[];
  doctors: any[];
  searchTerm: string = '';
  showCaseDivLoader: boolean;
  elementSlide: HTMLElement;
  mainElement: HTMLElement;
  assignedListShow: boolean;
  singlePatientFeedback: any;
  showOverlayFeedback: boolean;
  counter: number;
  showNoResult: boolean;
  showEmptyTemplate: boolean;
  listView: boolean = false;
  selectedDoc: string = "";
  selectedRating: string = "";
  mainViewError = new ErrorModel();
  constructor(private _service: HaFeedbackserviceService) {
  }

  ngOnInit() {
    this.counter = 1;
    this.getFeedbackData();
  }

  getDoctorsList() {
    this._service.getDoctorsList().subscribe((data: any[]) => {
      this.doctors = data;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayFeedback = false;
    });
  }

  getFeedbackData() {
    this.mainViewError.display = false;
    this.showOverlayFeedback = true;

    this._service.getFeedbackData().subscribe(
    (data: any[]) => {
      this.feedbackDataFiltered = data;
      this.feedbackDataOriginal = data;
      this.getDoctorsList();
      if (this.feedbackDataFiltered !== undefined && this.feedbackDataFiltered !== null) {
        if (this.feedbackDataFiltered.length < 1) {
          this.showEmptyTemplate = true;
        }
      } else {
        this.showEmptyTemplate = false;
      }
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
      this.showOverlayFeedback = false;
    });
  }

  openNav(caseId) {
    this.singlePatientFeedback = [];
    for (let cases of this.feedbackDataFiltered) {
      cases.border = "2px solid #eee";
    }
    let index = this.feedbackDataFiltered.findIndex(data => data.id == caseId);
    this.singlePatientFeedback = this.feedbackDataFiltered[index];
    this.feedbackDataFiltered[index].border = "2px solid #0969c9";
    this.elementSlide = document.getElementById('slideDiv1') as HTMLElement;
    this.elementSlide.style.marginRight = "0px";
    this.elementSlide.style.opacity = "1";
    this.mainElement = document.getElementById('main_content') as HTMLElement;
    this.mainElement.style.width = "70%";
  }

  closeNav() {
    for (let cases of this.feedbackDataFiltered) {
      cases.border = "2px solid #eee";
      cases.border = "";
    }
    this.singlePatientFeedback = [];
    this.elementSlide = document.getElementById('slideDiv1') as HTMLElement;
    this.elementSlide.style.marginRight = "-105%";
    this.elementSlide.style.opacity = "0";
    this.mainElement = document.getElementById('main_content') as HTMLElement;
    this.mainElement.style.width = "100%";
  }

  getFilteredList(event) {
    this.showCaseDivLoader = true;
    this.selectedRating = "";
    if (event == "") {
      this.feedbackDataFiltered = this.feedbackDataOriginal;
      this.showNoResultForFeedback();
    } else {
      this.feedbackDataFiltered = this.feedbackDataOriginal.filter(feedback => feedback.eaLogId == event);
      this.showNoResultForFeedback();
    }
  }

  showNoResultForFeedback() {
    let status = this.feedbackDataFiltered.length < 1 ? true : false;
    this.showEmptyTemplate = false;
    this.showNoResult = status;
    this.showCaseDivLoader = false;

  }

  onRateChange = (score) => {
    this.score = score;
  }

}
